import React, { Component } from 'react'
import { mailToEmailAddr } from './social.js'
/**
 * Basic component that renders a page footer
 */
export default class Footer extends Component {
  /**
   * Render the component
   */
  render () {
    const footerStyle = {
      width: '100%',
      height: 30,
      backgroundColor: '#D7D6D6',
      fontSize: 16,
      textAlign: 'center',
      paddingTop: 4,
      color: 'white',
      fontFamily: 'Oswald, sans-serif'
    }

    const copyrightStyle = {
      float: 'left',
      paddingLeft: 15
    }

    const feedbackStyle = {
      float: 'right',
      paddingRight: 15
    }

    const feedbackLinkStyle = {
      color: 'white',
      fontStyle: 'normal'
    }

    return (
      <footer style={footerStyle}>
        <div style={copyrightStyle}>© FinanceFreedom.io 2017</div>
        <div style={feedbackStyle}>
          <a style={feedbackLinkStyle} href={mailToEmailAddr}>
            Website Feedback
          </a>
        </div>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js